<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<!-- Loading Overlay for Modal Data -->
			<div v-if="loadModalData" class="loading-overlay">
				<div class="loading-spinner">
					<div class="spinner-border text-primary" role="status">
						<span class="visually-hidden">Loading ...</span>
					</div>
					<p class="mt-3">Loading Data ...</p>
				</div>
			</div>
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="row d-none">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<font-awesome-icon
									class="nav-icon"
									:icon="['fab', 'mailchimp']"
								/>
								Gorilla Permits&nbsp;&nbsp;
							</h4>
						</div>
					</div>

					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i
													class="nav-icon fas fa-handshake"
												></i
												>&nbsp;&nbsp;Reservation&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">
										&nbsp;&nbsp;Gorilla Permits&nbsp;&nbsp;
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row mb-1 d-flex p-2">
									<div class="col-md-12">
										<div class="mb-1">
											<label for="agent_id" class="form-label"
												>Select Registered Tour</label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												:items="infiniteTours.data || []"
												placeholder="Select Registerd Tour"
												v-model="filterPermits.tour"
												@update:modelValue="selectTour($event)"
												:item-title="tourSelect"
												item-value="id"
												clearable
											>
											</v-autocomplete>
										</div>
									</div>
									<div
										class="col-md-3 justify-content-start align-items-center gap-2 d-none"
										style="font-family: HeaderCustomFont"
									>
										<button
											type="submit"
											id="Filter"
											class="btn btn-info rounded-0 text-white"
										>
											<i class="nav-icon fas fa-filter"></i>&nbsp;&nbsp;Filter
										</button>
										<button
											type="button"
											id="Export"
											class="btn btn-danger rounded-0 text-white"
										>
											<i class="nav-icon fas fa-window-close"></i
											>&nbsp;&nbsp;Clear
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row col-sm-12">
									<div class="col-sm-7 float-sm-left text-start"></div>
									<div
										class="col-sm-5 text-end"
										style="font-family: HeaderCustomFont"
									>
										<!-- @click="openModal(modal, data)" -->
										<button
											class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
											@click="openModal('permits')"
											:disabled="!currentRoute"
										>
											<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
											Permit
										</button>
									</div>
								</div>
								<div class="row col-sm-12 mt-2">
									<div class="table-responsive p-1">
										<v-text-field
											v-model="searchPermits"
											label="Search Gorilla Permits"
											prepend-inner-icon="mdi-magnify"
											flat
											rounded="0"
											variant="outlined"
											density="compact"
											class="d-none"
										></v-text-field>
										<v-data-table
											v-model:items-per-page="permitPerPage"
											:headers="permitHeaders"
											:items="permitsComputed"
											:search="searchPermits"
											density="compact"
											item-value="id"
											class="table-sm table-striped rounded-0 text-truncate table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr v-for="item in items" :key="item.id">
													<td>{{ item.index + 1 }}</td>
													<td class="text-truncate" style="max-width: 200px">
														<v-tooltip location="top">
															<template v-slot:activator="{ props }">
																<span v-bind="props">{{
																	item.park?.park?.name
																}}</span>
															</template>
															<span>{{ item.park?.park?.name }}</span>
														</v-tooltip>
													</td>
													<td>
														{{ item.permit?.permit }}
													</td>
													<td>{{ item.pax }}</td>
													<td>{{ formatCurrency(item.permit_rate, "", 2) }}</td>
													<!-- <td>{{ item.currency }}</td> -->
													<td>{{ formatCurrency(item.amount, "", 2) }}</td>
													<td>{{ formatCurrency(item.amount_paid, "", 2) }}</td>
													<td class="align-middle">
														<v-menu v-if="currentRoute" offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>

															<v-list density="compact" class="custom-dropdown">
																<v-list-item
																	@click="managePermits(item, 'edit')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click="managePermits(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
											<template v-slot:body.append="{ items }">
												<tr
													class="font-weight-bold"
													style="font-family: HeaderCustomFont"
												>
													<td colspan="5" class="text-end">Totals</td>
													<td>
														{{
															formatCurrency(
																items.reduce(
																	(sum, item) => sum + Number(item.amount || 0),
																	0
																),
																"",
																2
															)
														}}
													</td>
													<td>
														{{
															formatCurrency(
																items.reduce(
																	(sum, item) =>
																		sum + Number(item.amount_paid || 0),
																	0
																),
																"",
																2
															)
														}}
													</td>
													<td></td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- </div> -->
				</div>
			</div>

			<v-dialog v-model="permitsModal" max-width="1250px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? managePermits(this.tourPermit, 'update')
								: managePermits(this.tourPermit, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Permits
								</h5>
							</div>
							<v-icon @click="closeModal('permits')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-4 required">
											<label for="name" class="form-label"
												><span
													v-if="tourPermit.errors.has('permit_id')"
													class="text-danger text-lowercase"
												>
													{{ tourPermit.errors.get("permit_id") }} </span
												><span v-else>Permit Type</span></label
											><v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												clearable
												placeholder="Select Permit Type"
												:items="this.infinitePermits.data"
												v-model="tourPermit.permit_id"
												item-value="id"
												item-title="permit"
												id="permit_id"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-4 required" v-if="!editMode">
											<label for="tour_activity" class="form-label"
												><span
													v-if="tourPermit.errors.has('tour_activity')"
													class="text-danger text-lowercase"
												>
													{{ tourPermit.errors.get("tour_activity") }} </span
												><span v-else>Tour Activity</span></label
											><v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												clearable
												placeholder="Select Tour Activity"
												:items="this.infiniteActivities.data"
												v-model="tourPermit.tour_activity"
												item-value="id"
												item-title="itinerary_title"
												id="tour_activity"
											>
											</v-autocomplete>
										</div>
										<div :class="editMode ? 'col-md-7 required' : 'col-md-4'">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="tourPermit.errors.has('park_id')"
														class="text-danger text-lowercase"
													>
														{{ tourPermit.errors.get("park_id") }} </span
													><span v-else>National Park</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select National Park"
													:items="this.infiniteParks.data"
													v-model="tourPermit.park_id"
													:item-value="id"
													:item-title="
														(item) => (item.park ? item.park.name : 'None')
													"
													id="park_id"
												>
												</v-autocomplete>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-2 required">
											<label for="name" class="form-label"
												><span
													v-if="tourPermit.errors.has('pax_category')"
													class="text-danger text-lowercase"
												>
													{{ tourPermit.errors.get("pax_category") }} </span
												><span v-else>Category</span></label
											><v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Category"
												:items="['ROA', 'FR', 'FNR', 'EAC']"
												v-model="tourPermit.pax_category"
												id="pax_category"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-2 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="tourPermit.errors.has('pax')"
														class="text-danger text-lowercase"
													>
														{{ tourPermit.errors.get("pax") }} </span
													><span v-else>Pax</span></label
												><v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Enter Pax"
													v-model="tourPermit.pax"
													id="pax"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-4 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="tourPermit.errors.has('permit_rate')"
														class="text-danger text-lowercase"
													>
														{{ tourPermit.errors.get("permit_rate") }} </span
													><span v-else>Rate</span></label
												><v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Enter Rate"
													v-model="tourPermit.permit_rate"
													id="permit_rate"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-4 required">
											<label for="currency" class="form-label"
												><span
													v-if="tourPermit.errors.has('currency')"
													class="text-danger text-lowercase"
												>
													{{ tourPermit.errors.get("currency") }}</span
												><span v-else>Currency</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Currency"
												:items="this.currencyList.data"
												v-model="tourPermit.currency"
												item-value="id"
												item-title="currency"
												id="currency"
											>
											</v-autocomplete>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-4 required">
											<label for="name" class="form-label"
												><span
													v-if="tourPermit.errors.has('amount')"
													class="text-danger text-lowercase"
												>
													{{ tourPermit.errors.get("amount") }} </span
												><span v-else>Total Amount</span></label
											><v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												disabled
												placeholder="Total Amount"
												v-model="tourPermit.amount"
												id="amount"
											></v-text-field>
										</div>
										<div class="col-md-4 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="tourPermit.errors.has('amount_paid')"
														class="text-danger text-lowercase"
													>
														{{ tourPermit.errors.get("amount_paid") }} </span
													><span v-else>Amount Paid</span></label
												><v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Enter Amount Paid"
													v-model="tourPermit.amount_paid"
													id="amount_paid"
												></v-text-field>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-12 required">
											<label for="name" class="form-label"
												><span
													v-if="tourPermit.errors.has('comment')"
													class="text-danger text-lowercase"
												>
													{{ tourPermit.errors.get("comment") }} </span
												><span v-else>Remarks</span></label
											><v-textarea
												density="compact"
												variant="outlined"
												rounded="0"
												rows="5"
												placeholder="Enter Remarks"
												v-model="tourPermit.comment"
												id="comment"
											></v-textarea>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
										:disabled="!currentRoute"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Permit
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('permits')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	components: {},
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			message: "",
			loadModalData: false,
			permitData: false,
			http_code: "",
			selectedTour: null,
			user: [],
			infiniteActivities: { data: [] },
			infiniteTours: { data: [] },
			infiniteParks: { data: [] },
			infinitePermits: { data: [] },
			currencyList: [],
			permitsModal: false,
			tourPermit: new Form({
				id: "",
				tour_id: null,
				tour_activity: null,
				permit_id: null,
				park_id: null,
				pax_category: null,
				pax: "",
				permit_rate: "",
				due_date: null,
				currency: null,
				amount_paid: "",
				amount: "",
				comment: "",
				is_deleted: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),
			filterPermits: new Form({
				start: null,
				end: null,
				tour: null,
			}),
			searchPermits: "",
			permitPerPage: 5,
			permits: [],
			permitHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Park", value: "park_id", sortable: true },
				{ title: "Category", value: "pax_category", sortable: true },
				{ title: "Pax", value: "pax", sortable: true },
				{ title: "Rate", value: "permit_rate", sortable: true },
				// { title: "Currency", value: "currency", sortable: true },
				{ title: "Amount", value: "amount", sortable: true },
				{ title: "Paid", value: "amount_paid", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],

			openPanels: {
				gorillaPermits: [0],
				filterTours: [0],
			},
			tourItinerary: new Form({
				id: "",
			}),
		};
	},
	methods: {
		async checkLogin() {
			var user_id = localStorage.getItem("user_id");
			var auth = localStorage.getItem("auth");

			if (auth == null || user_id == null) {
				this.$router.push("/");
				this.logout();
				this.$swal({
					text: "Session time out",
					icon: "error",
					position: "bottom-end",
					background: "#E74C3C",
					timer: 7500,
				});
			} else {
				let api = this.api + "/check";
				const query = await this.getData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					// perform other actions
					if (user_id !== null && auth !== null) {
						this.$router.push("/dash");
					}
				}

				if (query.result == "fail") {
					this.message = query.response.message;
					this.http_code = query.code;
					if (this.http_code == 503) {
						this.$swal({
							text: "Error " + this.http_code + ": " + this.message,
							icon: "error",
							position: "bottom-end",
							background: "#E74C3C",
						});
					}

					localStorage.clear();
					sessionStorage.clear();
				}
			}
		},
		async authUser() {
			var user_id = localStorage.getItem("user_id");
			var auth = localStorage.getItem("auth");

			if (user_id !== null && auth !== null) {
				var api = this.api + "/user/" + user_id;
				const query = await this.getData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.user = query.response.data;
					this.user_department = this.user.Department_id;
					localStorage.setItem("user_department", this.user.Department_id);
					localStorage.setItem("user_directorate", this.user.Directorate_id);
					localStorage.setItem(
						"selected_directorate",
						this.user.Directorate_id
					);
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
					this.$swal({
						text: "Error " + this.http_code + ": " + this.message,
						icon: "error",
						position: "bottom-end",
						background: "#E74C3C",
						timer: 7500,
					});
					this.$router.push("/");
				}
			}
		},
		async tourDetails(event) {
			// permit details
			this.tourPermit.tour_id = event;
		},
		async openModal(modal, mode) {
			var user_id = sessionStorage.getItem("user_id");
			this.tourDetails(this.selectedTour);

			// Show loading indicator
			this.loadModalData = true;

			try {
				// Lazy load cost modal data only when needed
				if (modal == "permits" && !this.permitData) {
					this.permitData = true;
					await Promise.all([
						this.getInfinites("permits"),
						this.getInfinites("parks"),
						this.getInfinites("activities"),
						this.getInfinites("currencies"),
					]);
				}
			} catch (error) {
				console.error("Error loading modal data:", error);
			} finally {
				// Hide loading indicator
				this.loadModalData = false;
			}

			if (modal == "permits") {
				if (mode == "update") {
					this.tourPermit.updated_by = user_id;
					this.editMode = true;
					this.permitsModal = true;
				} else {
					this.tourPermit.created_by = user_id;
					this.editMode = false;
					this.permitsModal = true;
				}
			}
		},
		closeModal(modal) {
			if (modal == "permits") {
				this.editMode = false;
				this.permitsModal = false;
				this.tourPermit.reset();
				this.tourPermit.errors.clear();
			}
		},
		async selectTour(event) {
			sessionStorage.removeItem("selected_tour");
			sessionStorage.setItem("selected_tour", JSON.stringify(event));
			this.selectedTour = event;
			this.showMessage("Tour " + event.reference_number + " selected!");
			await this.tourDetails(event);
			await this.managePermits("None", "fetch");
		},
		async getInfinites(mode) {
			var query, api;
			if (mode == "permits") {
				api = this.api + this.prefix + "/masters/permits";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.infinitePermits = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "parks") {
				api =
					this.api +
					this.prefix +
					"/reservation/park/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteParks = [];
					this.infiniteParks = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "tours") {
				api = this.api + this.prefix + "/reservation/tours";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.infiniteTours = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "activities") {
				api =
					this.api +
					this.prefix +
					"/reservation/itineraryz/" +
					this.selectedTour.tour_id;
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteActivities = [];
					this.infiniteActivities = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "currencies") {
				api = this.api + this.prefix + "/masters/currencies";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.currencyList = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async managePermits(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedTour !== null) {
					// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
					api =
						this.api +
						this.prefix +
						"/operations/permit/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.permits = query.response.data || query.response || [];
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/operations/permit";
				query = await this.postData(api, this.tourPermit);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("permits");
					this.managePermits("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/operations/permit/" + event.id;
				query = await this.putData(api, this.tourPermit);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("permits");
					this.managePermits("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourPermit.reset();
				this.tourPermit.fill(event);
				this.tourPermit.tour_id = event.tour;
				this.tourPermit.park_id = event.park;
				this.tourPermit.permit_id = event.permit;
				this.openModal("permits", "update");
			} else if (mode == "delete") {
				let confirmation = await this.showConfirmation("Delete this Permit?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/operations/permit/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("permits");
						this.managePermits("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
	},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/permits/");
		},
		tourSelect() {
			return (item) => {
				if (item && item.reference_number && item.client && item.agent_name) {
					return (
						item.reference_number + " (" + item.client + ") " + item.agent_name
					);
				}
			};
		},
		permitsComputed() {
			if (this.permits && this.permits.length > 0) {
				return this.permits.map((permit, index) => {
					return {
						...permit,
						index: index,
					};
				});
			}
			return [];
		},
		truncateTitle() {
			return {
				contentClass: "truncate-title",
			};
		},
	},
	async created() {
		await this.getInfinites("tours");

		if (this.selectedTour == null) {
			if (
				sessionStorage.getItem("selected_tour") !== "" ||
				sessionStorage.getItem("selected_tour") !== null
			) {
				let selected = JSON.parse(sessionStorage.getItem("selected_tour"));
				this.selectedTour = selected;
				this.filterPermits.tour = this.selectedTour;
				this.selectTour(selected);
			}
		}
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>



